module.exports = __webpack_public_path__ + "img/4.fd0f88ad.png";